import React, {useEffect, useState} from 'react'
import SearchableSelect from '../../../../components/SearchableSelect/SearchableSelect'
import {getSmjenePanelaDropdown} from '../../../../api/glavnaKnjigaProizvodnje'
import {Option} from '../../../../models/Sektor'
interface DropdownProps {
  value?: string | number
  initialValue?: string | number
  onChange?: (name: string, value: any) => void
  errors?: string | undefined
  touched?: boolean
  selectName?: string
}

const SmjenePanelaDropdown: React.FC<DropdownProps> = ({
  value,
  initialValue,
  onChange,
  errors,
  touched,
  selectName,
}) => {
  const [SmjenePanelaDropdown, setSmjenePanelaDropdown] = useState<Array<Option>>([])
  const internalValue = initialValue ?? null

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getSmjenePanelaDropdown()
        setSmjenePanelaDropdown(mapData(response.data.data))
      } catch (error) {
        console.error('Error fetching dropdown data:', error)
      }
    }
    fetchData()
  }, [])

  const finalValue = value ?? internalValue

  const mapData = (data) => {
    if (!data) {
      return []
    }
    return data.map((item) => ({label: item.Naziv, value: item.Id.toString()}))
  }

  return (
    <SearchableSelect
      options={SmjenePanelaDropdown}
      value={finalValue?.toString() ?? ''}
      onChange={onChange!}
      name={selectName ?? 'SmjenePanelaDropdown'}
      errors={errors}
      placeholder='Odaberi Smjenu'
      touched={touched}
    />
  )
}

export default SmjenePanelaDropdown
